/**
 * 环境配置 - 开发/线上 两套配置（参考 sfd 项目）
 * - npm run build / build:dev  → 开发环境 (dev)
 * - npm run build:prod        → 线上环境 (prod)
 * DefinePlugin 在编译时将 __KCONFIG_ENV__ 替换为 "prod" 或 "dev"
 * 发布时请根据实际服务器修改 prod.backendBaseUrl
 */
const kconfig = (function () {
  function kconfig() {}

  const env = typeof __KCONFIG_ENV__ !== 'undefined' ? __KCONFIG_ENV__ : 'dev';

  const presets = {
    dev: {
      // 与 sfd 相同：使用完整后端地址，依赖 aichatbackend 的 CORS（AllowAnyOrigin）
      backendBaseUrl: 'http://localhost/aichatbackend'
    },
    prod: {
      backendBaseUrl: 'https://demo.slickflow.com/aichatbackend'
    },
    proxy: {
      // 通过 dev server 代理，避免跨域（npm run start:proxy 时使用）
      backendBaseUrl: ''
    }
  };

  const selected = presets[env] || presets.dev;
  kconfig.backendBaseUrl = selected.backendBaseUrl;

  return kconfig;
})();

export default kconfig;
